import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
    namespaced: true,
    state: {
        socket: null,
        obj: [],
        list: [],
    },
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// src/store/socket/index.js